import { render, staticRenderFns } from "./TasksDetail.vue?vue&type=template&id=e7833ff2"
import script from "./TasksDetail.vue?vue&type=script&lang=js"
export * from "./TasksDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports